// extracted by mini-css-extract-plugin
export default {"Container":"lGkhtVeiyyN7pIaVOidL","cds--modal-content":"VHcP04rf3NJgod1pqzyg","SummaryText":"_0RHk4lEY7lTHRJHBUSQG"};